import React, { FC } from 'react';
import { Offer } from '@funtech-int/yango-shared';

import { useHasSubscription } from '@/shared/hooks/useHasSubscription';
import { MediaBillingFeature } from '@/shared/constants/billingFeatures';

import { OfferContentComponent } from './OfferContentComponent';

interface Props {
    billingFeatureName: string;
    offer: Offer;
}
export const OfferContent: FC<Props> = ({ billingFeatureName, offer }) => {
    const hasSubscription = useHasSubscription();
    if (billingFeatureName === MediaBillingFeature.AMEDIATEKA && hasSubscription) {
        return <OfferContentComponent offer={offer} isUpsale />;
    }

    return <OfferContentComponent offer={offer} />;
};
